import React from "react";

export interface SupportChatIconProps {
  fill?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

const SupportChatIcon: React.FC<SupportChatIconProps> = ({
  fill = "#E4E4E4",
  width = 24,
  height = 24,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M10.3125 17.979V18.5415L12.8438 16.6431C13.125 16.4321 13.4766 16.2915 13.8633 16.2915H18.75C19.0312 16.2915 19.3125 16.0454 19.3125 15.729V5.604C19.3125 5.32275 19.0312 5.0415 18.75 5.0415H5.25C4.93359 5.0415 4.6875 5.32275 4.6875 5.604V15.729C4.6875 16.0454 4.93359 16.2915 5.25 16.2915H8.625C9.53906 16.2915 10.3125 17.0649 10.3125 17.979ZM10.2773 20.686L10.1016 20.7915L9.50391 21.2485C9.32812 21.3892 9.11719 21.3892 8.90625 21.3188C8.73047 21.2134 8.625 21.0376 8.625 20.7915V17.979H5.25C3.98438 17.979 3 16.9946 3 15.729V5.604C3 4.37354 3.98438 3.354 5.25 3.354H18.75C19.9805 3.354 21 4.37354 21 5.604V15.729C21 16.9946 19.9805 17.979 18.75 17.979H13.8633L10.3125 20.6509L10.2773 20.686ZM8.94141 7.50244C9.22266 6.69385 9.96094 6.1665 10.8047 6.1665H12.8438C14.0742 6.1665 15.0586 7.18604 15.0586 8.4165C15.0586 9.18994 14.6367 9.92822 13.9688 10.3149L12.8086 10.9829C12.8086 11.4399 12.457 11.7915 11.9648 11.7915C11.5078 11.7915 11.1211 11.4399 11.1211 10.9478V10.4907C11.1211 10.1743 11.2969 9.89307 11.5781 9.75244L13.125 8.87354C13.3008 8.76807 13.3711 8.59229 13.3711 8.4165C13.3711 8.1001 13.1602 7.854 12.8438 7.854H10.8047C10.6992 7.854 10.5938 7.95947 10.5586 8.06494L10.5234 8.1001C10.3828 8.52197 9.89062 8.76807 9.46875 8.62744C9.01172 8.45166 8.80078 7.95947 8.94141 7.5376V7.50244ZM13.125 14.0415C13.125 14.6743 12.5977 15.1665 12 15.1665C11.3672 15.1665 10.875 14.6743 10.875 14.0415C10.875 13.4438 11.3672 12.9165 12 12.9165C12.5977 12.9165 13.125 13.4438 13.125 14.0415Z"
        fill={fill}
      />
    </svg>
  );
};

export default SupportChatIcon;
